import React from 'react';
import { TasksContext } from './TasksContext';
import { useTasks } from '../hooks/useTasks';

type TasksProviderProps = {
  children: React.ReactNode;
};

export const TasksProvider = ({ children }: TasksProviderProps): JSX.Element => {
  const providerValue = useTasks();
  return <TasksContext.Provider value={providerValue}>{children}</TasksContext.Provider>;
};
